import React, { FunctionComponent } from 'react';
import { Alert } from 'react-bootstrap';
import { Table } from '@views/components/cart';
import { TABLE_COL } from '../../intl';
import IconMessage from '@views/static/icon-message.svg';

export const Message: FunctionComponent = () => (
  <Table.Row key="__message__" message>
    <Table.Col colSpan={5}>
      <Table.Message>
        <IconMessage />
        <span>{TABLE_COL.MESSAGE}</span>
      </Table.Message>
    </Table.Col>
  </Table.Row>
);

export const ContactProductMessage = () => (
  <Table.Row key="__contact__" message>
    <Table.Col colSpan={5}>
      <Alert variant="warning">
        Văn Phòng Phẩm ABC sẽ liên hệ trực tiếp với khách hàng để xác nhận giá
        bán sản phẩm sau khi đơn hàng được đặt thành công
      </Alert>
    </Table.Col>
  </Table.Row>
);

export default Message;
